import { EditOutlined } from "@mui/icons-material";
import { AvatarGroup, Box, ButtonBase, Divider, styled } from "@mui/material";
import React from "react";
import { useAppDispatch } from "../../redux";
import { useGetUsersAsOptionsQuery, User } from "../../redux/services";
import { closeDialog, openDialog } from "../../redux/slices/dialog";
import { UserAvatar } from "../userAvatar";
import { AddEditUser } from "./addEditUser";

const HeadingButton = styled(ButtonBase)(({ theme }) => ({
    fontSize: 12,
    width: '100%',
    textAlign: 'left',
    paddingTop: '4px',
    paddingBottom: '2px',
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
    fontFamily: 'htrts_regular',
    '&:hover,&:focus': {
        fontFamily: 'htrts_medium',
        paddingLeft: '4px',
        paddingRight: '4px',
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
    },
    '& span': {
        width: '100%',
    },
    '& svg': {
        width: 16,
        height: 16,
    },
}));

export const UserStack: React.FC<{
    user?: string[],
    users?: User[],
    title?: string,
    buttonName?: string,
    hideAddBtn?: boolean,
    updatedUsers?: (users: User[]) => void,
    hideHeader?: boolean,
    hideBorder?: boolean,
    avatarSize?: 'small' | 'medium' | 'large',
    max?: number,
    onlyUsers?: string[]
}> = ({
    user = [],
    users = [],
    title = '',
    buttonName = '',
    hideAddBtn = false,
    updatedUsers = (users) => false,
    hideBorder = false,
    hideHeader = false,
    avatarSize = 'medium',
    max = 5,
    onlyUsers = []
}) => {

        const dispatch = useAppDispatch();

        const { data, isFetching, isLoading, isError, isSuccess } = useGetUsersAsOptionsQuery(null);

        const [userStack, setUserStack] = React.useState<User[]>(users);

        const widthHeight = {
            'small': { width: 24, height: 24, fontSize: '0.65rem' },
            'medium': {},
            'large': { width: 56, height: 56, fontSize: '0.65rem' },
        }

        const addEditUser = () => {

            let userData = data ?? [];

            if (onlyUsers.length) {
                userData = userData.filter(user => onlyUsers.includes(`${user.value}`));
            }

            dispatch(openDialog({
                title: `Add/Edit ${buttonName}`,
                body: <AddEditUser
                    data={userData}
                    isFetching={isFetching}
                    isLoading={isLoading}
                    isError={isError}
                    users={userStack}
                    onUpdate={(users) => {
                        setUserStack(users);
                        updatedUsers(users);
                        dispatch(closeDialog());
                    }}
                />,
                hideNegativeBtn: true,
                hidePositiveBtn: true
            }));
        };

        React.useEffect(() => {
            if (user.length && isSuccess && data.length) {
                let newUserStack = data.filter(_user => user.includes(`${_user.value}`));
                setUserStack(newUserStack as unknown as User[]);
            }
            // eslint-disable-next-line
        }, [user, isSuccess]);

        return <Box>            

            {!hideHeader && <>
                <HeadingButton onClick={() => addEditUser()}>
                    <span>{title}</span>
                    <EditOutlined fontSize='small' />
                </HeadingButton>

                <Divider sx={{ mt: '1px' }} />
            </>}

            <Box sx={{ m: hideBorder ? 0 : 1, display: "flex", justifyContent: "flex-start" }}>
                <AvatarGroup max={max}>
                    {userStack.map((user) => <UserAvatar key={user.user_id} userId={user.user_id} name={user.name} avatarUrl={""} sx={{ ...widthHeight[avatarSize] }} />)}
                </AvatarGroup>
            </Box>
        </Box>
    }